import React from "react";
import TspConferenceProgram from "./TspConferenceProgram/TspConferenceProgram";

const ScientificProgram = () => {
  return <TspConferenceProgram />;
};

export default ScientificProgram;
